import { Grid } from '@mui/material';
import FieldText from '../../../../components/general/fields/fieldText';
import LoadingButtonGeneral from '../../../../components/general/buttons/loadingButtonGeneral';
import { FinalCausalityFiltersProps } from './props';
import { useFinalCausalityFilters } from './hook';
import { formatParams } from '../../../../../shared/utils/params';
import AutocompleteField from '../../../../components/general/fields/autocompleteField';
import { Checkbox } from '../../../../components/general/fields/checkbox';

export const FinalCausalityFilters = ({
    onFilter,
    loading,
}: FinalCausalityFiltersProps) => {
    const { formik, causalities } = useFinalCausalityFilters(onFilter);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
        >
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(causalities)}
                    label="Causalidad final"
                    name="finalCausality"
                    size="small"
                    touched={formik.touched.finalCausality}
                    errors={formik.errors.finalCausality}
                    value={formik.values.finalCausality as string}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('finalCausality', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Número causa"
                    name="causeNumber"
                    size="small"
                    touched={formik.touched.causeNumber}
                    errors={formik.errors.causeNumber}
                    value={formik.values.causeNumber}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Causa real"
                    name="realCause"
                    size="small"
                    touched={formik.touched.realCause}
                    errors={formik.errors.realCause}
                    value={formik.values.realCause}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <Checkbox
                    label="Activo"
                    checked={Boolean(formik.values.active)}
                    onChange={() => {
                        formik.setFieldValue('active', !formik.values.active);
                    }}
                />
            </Grid>
            <Grid item xs={12}>
                <LoadingButtonGeneral
                    disabled={loading}
                    title="Buscar"
                    sx={{ mr: 1 }}
                    onClick={formik.submitForm}
                />
                <LoadingButtonGeneral
                    disabled={loading}
                    title="Limpiar"
                    variant="outlined"
                    onClick={formik.resetForm}
                />
            </Grid>
        </Grid>
    );
};
